module.exports = __webpack_public_path__ + "img/training.72957efc.svg";